import React, { useState } from 'react';
import Modal from 'react-modal';
import { LightIconSvg } from '../../icons';
import { ModalContainer, ModalContent, ModalHeader, ModalStyle } from '../../common/modals';
import { Slider, Switch } from '../../common';
// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('html');
export var LightCardModal = function (props) {
    var color = useState('#F8CC46')[0];
    var stateLabel = props.capabilities.SUPPORT_BRIGHTNESS ?
        (props.brightness && props.brightness > 0 ? "".concat(props.brightness, "% Brightness") : props.state) :
        (props.state);
    function handleSliderChange(value) {
        if (props.onBrightnessChange) {
            props.onBrightnessChange(value);
        }
    }
    return (React.createElement(Modal, { isOpen: props.show, onRequestClose: props.close, contentLabel: "Example Modal", style: ModalStyle },
        React.createElement(ModalContainer, null,
            React.createElement(ModalHeader, { title: props.name, subtitle: stateLabel, close: props.close, icon: React.createElement(LightIconSvg, null) }),
            React.createElement(ModalContent, null,
                props.capabilities.SUPPORT_BRIGHTNESS ?
                    React.createElement(Slider, { value: props.brightness || 0, onChange: handleSliderChange, color: color }) :
                    React.createElement(Switch, { isActive: props.on, onToggle: function () { return props.onToggle && props.onToggle(); } }),
                props.capabilities.SUPPORT_COLOR ?
                    React.createElement("div", null, "TODO: Implement color picker") : null))));
};
//# sourceMappingURL=LightCardModal.js.map